import React from 'react';
import ConfluencePage from '../ConfluencePage/ConfluencePage';
import { CODE_DEVELOPMENT } from '../../constants/confluenceConstants';
import '../../css/confluence.css';

const CodeDevelopment = () => {
  return (
    <ConfluencePage pageName={CODE_DEVELOPMENT} />
  );
};

export default CodeDevelopment;
